import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PricingCards, PlanId } from './PricingCards';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('kitpro');
  return <section id="pricing" className="py-14 md:py-20 bg-surface relative scroll-mt-12" data-id="element-232">
      <div className="container mx-auto px-5 md:px-6" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-10" data-id="element-234">
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3" data-id="element-235">
            ELEGÍ TU <span className="text-primary italic" data-id="element-236">PLAN</span>
          </h2>
          <p className="text-sm md:text-lg text-text-muted" data-id="element-237">
            Seleccioná tu opción y comenzá hoy mismo.
          </p>
        </motion.div>

        <PricingCards selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-238" />
      </div>
    </section>;
}